export const getMicroCopy = (key: string, data: Record<string, string>): string => data[key] || '';
